
export const socketurl='wss://1-be-pisaccosaasbackendcontroller.pitech.co.ug'